(function () {
  document.querySelectorAll('.lnc[data-lnc]').forEach(function (root) { if (!root.__lnc) { root.__lnc = 1; init(root); } });
  function init(root) {
  var dataEl = document.getElementById(root.id.replace('lnc-', 'lnc-data-'));
  if (!dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var app = root.querySelector('[data-lnc-app]');
  var ROUTE = root.getAttribute('data-root') || '/';
  if (ROUTE.slice(-1) !== '/') ROUTE += '/';
  var RATE = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
  var SEUIL = Math.round((parseInt(root.getAttribute('data-seuil'), 10) || 5000) * RATE);
  var SHIP_RAW = parseInt(root.getAttribute('data-ship'), 10) || 0;
  var SHIP = SHIP_RAW > 0 ? Math.round(SHIP_RAW * RATE) : SHIP_RAW;
  var SHIP_MODE = root.getAttribute('data-ship-mode') || '';
  // Langue : textes dans assets/ln-configurateur-i18n.js
  var I = window.LNC_I18N || {};
  var LANG = String((window.Shopify && Shopify.locale) || document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var L = I[LANG] || I.fr || {};
  var LF = I.fr || {};
  // Titres des groupes de couleurs : nouvelle collection / dernières pièces
  var GRP = ({
    fr: ['Nouvelle collection', 'Dernières pièces', 'Collection précédente · quantités limitées'],
    en: ['New collection', 'Last pieces', 'Previous collection · limited stock'],
    de: ['Neue Kollektion', 'Letzte Stücke', 'Vorherige Kollektion · begrenzte Stückzahl'],
    es: ['Nueva colección', 'Últimas unidades', 'Colección anterior · cantidades limitadas'],
    it: ['Nuova collezione', 'Ultimi pezzi', 'Collezione precedente · quantità limitate'],
    nl: ['Nieuwe collectie', 'Laatste stuks', 'Vorige collectie · beperkte voorraad']
  })[LANG] || ['Nouvelle collection', 'Dernières pièces', 'Collection précédente · quantités limitées'];
  // Étape charms sans anneau choisi : on montre tous les charms, avec leurs anneaux compatibles
  var NR = ({
    fr: ['Tous nos charms', 'Anneaux compatibles : {x}'],
    en: ['All our charms', 'Compatible hoops: {x}'],
    de: ['Alle unsere Charms', 'Passende Creolen: {x}'],
    es: ['Todos nuestros charms', 'Aros compatibles: {x}'],
    it: ['Tutti i nostri charm', 'Cerchi compatibili: {x}'],
    nl: ['Al onze charms', 'Passende oorringen: {x}']
  })[LANG] || ['Tous nos charms', 'Anneaux compatibles : {x}'];
  // Arrivée depuis une fiche créoles : sous-titre du résumé d'anneaux
  var FL = ({
    fr: 'Les anneaux de vos créoles', en: 'The hoops of your earrings', de: 'Die Ringe Ihrer Creolen',
    es: 'Los aros de tus pendientes', it: 'I cerchi dei tuoi orecchini', nl: 'De ringen van je oorbellen'
  })[LANG] || 'Les anneaux de vos créoles';
  // Charms ajoutés sans anneaux
  var CIN = ({
    fr: 'Vos charms sont dans le panier. Ajoutez des anneaux ou d\'autres charms.',
    en: 'Your charms are in your cart. Add some hoops or more charms.',
    de: 'Ihre Charms sind im Warenkorb. Fügen Sie Creolen oder weitere Charms hinzu.',
    es: 'Tus charms están en el carrito. Añade aros u otros charms.',
    it: 'I tuoi charm sono nel carrello. Aggiungi dei cerchi o altri charm.',
    nl: 'Je charms zitten in je winkelmand. Voeg oorringen of meer charms toe.'
  })[LANG] || 'Vos charms sont dans le panier. Ajoutez des anneaux ou d\'autres charms.';
  function t(k, v) {
    var s = L[k] != null ? L[k] : LF[k];
    if (s == null) return k;
    v = v || {};
    return String(s).replace(/\{(\w+)\}/g, function (m, a) { return v[a] != null ? v[a] : m; });
  }
  function tp(k, n) { var a = L[k] || LF[k]; return (n > 1 ? a[1] : a[0]).replace('{n}', n); }
  function lc(s) { return LANG === 'de' ? s : s.charAt(0).toLowerCase() + s.slice(1); }
  function cBase(name) { var b = String(name).replace(/\s*acétate$/i, ''); return (L.base && L.base[b]) || b; }
  function cName(name) { return L.charm(cBase(name), /acétate$/i.test(name)); }
  function rShort(r) { return L.ringShort(r.n, r.silver); }
  function rLong(r) { return L.ringLong(r.n, r.silver); }
  var ICON = {
    gift: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13"/><path d="M12 7c-1.5-3-5-3.5-5-1.2C7 7 9.5 7 12 7c2.5 0 5 0 5-1.2C17 3.5 13.5 4 12 7z"/></svg>',
    truck: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2zM13 10h4l3 3v3h-7z"/><circle cx="6" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>',
    box: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7l9-4 9 4v10l-9 4-9-4z"/><path d="M3 7l9 4 9-4M12 11v10"/></svg>',
    pouch: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 9h14l-1.5 11h-11z"/><path d="M8 9V7a4 4 0 0 1 8 0v2"/></svg>',
    van: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2zM13 10h4l3 3v3h-7z"/><circle cx="6" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>'
  };

  var FORMATS = {
    1: { size: '2 cm', weight: '2 g', sw: 2.4 },
    2: { size: '2 cm', weight: '2,6 g', sw: 3.6 },
    3: { size: '2 cm', weight: '3 g', sw: 6 },
    4: { size: '1,6 cm', weight: '< 1 g', sw: 2.4 }
  };
  var RINGS = D.rings.map(function (r) {
    return { id: r.id, n: parseInt(r.code, 10), silver: /a/i.test(r.code.replace(/^\d+/, '')), price: r.price, available: r.available, img: r.img };
  }).filter(function (r) { return FORMATS[r.n]; });
  var CHARMS = D.charms.map(function (c) {
    c.rings = String(c.rings || '').split(/[^0-9]+/).filter(Boolean).map(Number);
    // Couleurs classées par meilleures ventes (réglage « order »), les épuisées à la fin
    var ord = String(c.order || '').split(/[^0-9]+/).filter(Boolean).map(Number);
    // Dernières pièces (ancienne collection) : toujours après la nouvelle collection, avec leur propre ordre
    var ordL = String(c.order_last || '').split(/[^0-9]+/).filter(Boolean).map(Number);
    var rk = function (v) { var o = v.last ? ordL : ord; var k = o.indexOf(parseInt(v.num, 10)); return k === -1 ? 999 : k; };
    c.variants = c.variants.map(function (v, i) { return { v: v, i: i }; }).sort(function (a, b) {
      return ((a.v.last ? 1 : 0) - (b.v.last ? 1 : 0)) || (b.v.available - a.v.available) || (rk(a.v) - rk(b.v)) || (a.i - b.i);
    }).map(function (x) { return x.v; });
    c.hasLast = c.variants.some(function (v) { return v.last; });
    return c;
  }).filter(function (c) { return c.rings.length && c.variants.length; });
  if (!RINGS.length || !CHARMS.length || !L.ringShort) { app.innerHTML = '<p class="lnc__loading">' + t('unavailable') + '</p>'; return; }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  function money(c) {
    var v = c / 100;
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: cur, minimumFractionDigits: v % 1 ? 2 : 0 }).format(v); }
    catch (e) { return v.toFixed(2).replace('.', ',') + ' €'; }
  }
  function ringOf(n, silver) { return RINGS.filter(function (r) { return r.n === n && r.silver === silver; })[0]; }
  function firstAvail(c) { for (var i = 0; i < c.variants.length; i++) if (c.variants[i].available) return i; return 0; }
  function compat(n) { var out = []; CHARMS.forEach(function (c, i) { if (c.rings.indexOf(n) !== -1) out.push(i); }); return out; }
  function baseNames(list) { var out = []; list.forEach(function (i) { var b = cBase(CHARMS[i].name); if (out.indexOf(b) === -1) out.push(b); }); return out; }
  var GID = 0;
  function ringSvg(n, silver, size) {
    var f = FORMATS[n]; var R = n === 4 ? 31 : 39; var sw = f.sw * 2.4;
    var id = 'lncg' + (++GID);
    var st = silver
      ? ['#5F656C', '#F7F9FA', '#AEB4BB', '#6B7178', '#D9DDE1']
      : ['#7E5C17', '#FBEAB2', '#C9A042', '#86651F', '#E7C46E'];
    var hi = silver ? '#FFFFFF' : '#FFF6D6';
    var top = 60 - R;
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 120 120" aria-hidden="true">' +
      '<defs><linearGradient id="' + id + '" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0" stop-color="' + st[0] + '"/><stop offset=".28" stop-color="' + st[1] + '"/><stop offset=".5" stop-color="' + st[2] + '"/><stop offset=".78" stop-color="' + st[3] + '"/><stop offset="1" stop-color="' + st[4] + '"/></linearGradient></defs>' +
      '<ellipse cx="60" cy="' + (60 + R + sw / 2 + 5) + '" rx="' + (R * 0.75) + '" ry="3.2" fill="#3D1127" opacity=".10"/>' +
      '<circle cx="60" cy="60" r="' + R + '" fill="none" stroke="url(#' + id + ')" stroke-width="' + sw + '"/>' +
      '<circle cx="60" cy="60" r="' + (R - sw / 2 + 0.6) + '" fill="none" stroke="' + st[0] + '" stroke-width="1" opacity=".35"/>' +
      '<circle cx="60" cy="60" r="' + (R + sw * 0.12) + '" fill="none" stroke="' + hi + '" stroke-width="' + Math.max(1, sw * 0.22) + '" stroke-linecap="round" opacity=".85" stroke-dasharray="' + (R * 1.25) + ' 999" transform="rotate(200 60 60)"/>' +
      '<circle cx="60" cy="60" r="' + R + '" fill="none" stroke="' + hi + '" stroke-width="' + Math.max(0.8, sw * 0.15) + '" stroke-linecap="round" opacity=".5" stroke-dasharray="' + (R * 0.5) + ' 999" transform="rotate(20 60 60)"/>' +
      '<line x1="66" y1="' + (top - sw / 2) + '" x2="66" y2="' + (top + sw / 2) + '" stroke="' + st[0] + '" stroke-width="1.3" opacity=".55"/></svg>';
  }
  function plural(n, one, many) { return n + ' ' + (n > 1 ? many : one); }

  var S = { step: 'anneaux', n: 2, silver: false, own: false, ci: 0, picks: [], note: '', busy: false, sheet: false, cart: 0, zoom: null, rq: {}, gift: false };
  function ringList() { return RINGS.filter(function (r) { return (S.rq[r.id] || 0) > 0; }); }
  function nbRings() { return ringList().reduce(function (a, r) { return a + S.rq[r.id]; }, 0); }
  function ringFormats() {
    if (S.own) return [S.n];
    var out = []; ringList().forEach(function (r) { if (out.indexOf(r.n) === -1) out.push(r.n); });
    return out.length ? out : [1, 2, 3, 4];
  }
  function compatAny(ns) { var out = []; CHARMS.forEach(function (c, i) { if (ns.some(function (n) { return c.rings.indexOf(n) !== -1; })) out.push(i); }); return out; }
  function prunePicks(o) {
    var ns = ringFormats();
    var kept = S.picks.filter(function (p) { return ns.some(function (n) { return CHARMS[p.ci].rings.indexOf(n) !== -1; }); });
    var removed = S.picks.length - kept.length;
    o = o || {}; o.picks = kept;
    o.note = removed ? t('removed', { x: tp('pCharm', removed) }) : '';
    return o;
  }
  // Aucun anneau présélectionné : la cliente choisit elle-même ses anneaux
  function defaultRings() { return {}; }
  function nextAvail(from, dir) { var vs = CHARMS[S.ci].variants, n = vs.length, i = from; for (var k = 0; k < n; k++) { i = (i + dir + n) % n; if (vs[i].available) return i; } return from; }
  function togglePick(ci, vi) { var k = pickIndex(ci, vi), p = S.picks.slice(); if (k === -1) p.push({ ci: ci, vi: vi }); else p.splice(k, 1); return p; }
  if (!ringOf(2, false)) S.n = RINGS[0].n;
  S.rq = defaultRings();
  // Lien depuis une fiche créoles (« Voir tous les charms compatibles ») : ?lnc_format=1..4
  // → anneaux déjà à elle, dans ce format, et ouverture directe sur l'étape charms
  try {
    var qf = parseInt(new URLSearchParams(window.location.search).get('lnc_format'), 10);
    if (FORMATS[qf] && !root.classList.contains('lnc--home')) { S.own = true; S.n = qf; S.step = 'charms'; S.fromLink = true; }
  } catch (e) {}

  function set(o) { for (var k in o) S[k] = o[k]; render(); }
  function pickIndex(ci, vi) { for (var k = 0; k < S.picks.length; k++) if (S.picks[k].ci === ci && S.picks[k].vi === vi) return k; return -1; }
  function countIn(ci) { return S.picks.filter(function (p) { return p.ci === ci; }).length; }
  function cartDrawerOpen() {
    try {
      var oc = document.getElementById('opus-shadow-container');
      var od = oc && oc.shadowRoot && oc.shadowRoot.querySelector('.opus-drawer-container');
      if (od && od.classList.contains('open')) return true;
      var dr = document.getElementById('cart-drawer');
      if (dr && (dr.open || dr.hasAttribute('open')) && getComputedStyle(dr).visibility !== 'hidden') return true;
    } catch (e) {}
    return false;
  }
  function toTop() { var r = root.getBoundingClientRect(); if (r.top < 0) window.scrollTo({ top: window.pageYOffset + r.top - 80, behavior: 'smooth' }); }

  function render() {
    var keep = document.activeElement && root.contains(document.activeElement) ? document.activeElement.getAttribute('data-k') : null;
    var f = FORMATS[S.n], ring = ringOf(S.n, S.silver);
    var list = S.own ? [] : ringList(), nbR = S.own ? 0 : nbRings();
    var ns = ringFormats();
    var okList = compatAny(ns);
    if (okList.indexOf(S.ci) === -1) S.ci = okList.length ? okList[0] : 0;
    var ringPrice = list.reduce(function (a, r) { return a + r.price * S.rq[r.id]; }, 0);
    var charmsTotal = S.picks.reduce(function (a, p) { return a + CHARMS[p.ci].variants[p.vi].price; }, 0);
    var total = ringPrice + charmsTotal;
    var allAvail = list.every(function (r) { return r.available; });
    var ringOk = S.own || (nbR > 0 && allAvail);
    var ringTxt = S.own ? t('own', { x: L.fmt[S.n] })
      : !nbR ? t('noneM')
      : list.length === 1 ? (nbR > 1 ? nbR + ' × ' : '') + rShort(list[0])
      : tp('pRing', nbR);
    var h = '';

    // Étapes
    var s2 = S.picks.length ? tp('pChosen', S.picks.length) : t('noneF');
    h += '<div class="lnc-steps" role="tablist" aria-label="' + esc(t('stepsAria')) + '">' +
      '<button type="button" role="tab" class="lnc-step" data-k="s1" data-a="step" data-v="anneaux" aria-selected="' + (S.step === 'anneaux') + '"><small>' + t('step1') + '</small><strong>' + t('rings') + '</strong><span>' + esc(ringTxt) + '</span></button>' +
      '<button type="button" role="tab" class="lnc-step" data-k="s2" data-a="step" data-v="charms" aria-selected="' + (S.step === 'charms') + '"><small>' + t('step2') + '</small><strong>' + t('charms') + '</strong><span>' + esc(s2) + '</span></button></div>';

    if (S.note) h += '<div class="lnc-note" role="status"><p>' + esc(S.note) + '</p><button type="button" data-k="nx" data-a="note" aria-label="' + esc(t('close')) + '">×</button></div>';

    if (S.step === 'anneaux') {
      var cntG = 0, cntS = 0; list.forEach(function (r) { if (r.silver) cntS += S.rq[r.id]; else cntG += S.rq[r.id]; });
      h += '<div class="lnc-finish" role="group" aria-label="' + esc(t('finishAria')) + '">' +
        '<button type="button" data-k="f0" data-a="finish" data-v="0" aria-pressed="' + !S.silver + '"><span class="lnc-dot" style="background:#C59B3E"></span>' + t('gold') + (cntG ? '<b class="lnc-fc" style="display:inline-flex;align-items:center;justify-content:center;min-width:20px;height:20px;padding:0 6px;margin-left:2px;border-radius:999px;background:#D62F92;color:#fff;font-size:11.5px;font-weight:700">' + cntG + '</b>' : '') + '</button>' +
        '<button type="button" data-k="f1" data-a="finish" data-v="1" aria-pressed="' + S.silver + '"><span class="lnc-dot" style="background:#A3A9B1"></span>' + t('silver') + (cntS ? '<b class="lnc-fc" style="display:inline-flex;align-items:center;justify-content:center;min-width:20px;height:20px;padding:0 6px;margin-left:2px;border-radius:999px;background:#D62F92;color:#fff;font-size:11.5px;font-weight:700">' + cntS + '</b>' : '') + '</button></div>';
      h += '<p class="lnc-hint lnc-hint--c">' + (S.own ? t('ownQ') : t('ringHint')) + '</p>';
      h += '<div class="lnc-rings">';
      [1, 2, 3, 4].forEach(function (n) {
        var r = ringOf(n, S.silver); if (!r) return;
        var F = FORMATS[n];
        var off = !S.own && !r.available;
        var q = S.own ? 0 : (S.rq[r.id] || 0);
        var sel = S.own ? S.n === n : q > 0;
        h += '<div class="lnc-ring' + (off ? ' is-off' : '') + (sel ? ' is-on' : '') + '"><button type="button" class="lnc-ring__main" data-k="r' + n + '" data-a="ring" data-v="' + n + '" aria-pressed="' + sel + '">' +
          (n === 2 ? '<span class="lnc-flag lnc-flag--best">' + t('best') + '</span>' : '') +
          ringSvg(n, S.silver, 60) +
          '<strong><span class="lnc-num" aria-label="' + esc(t('numAria', { x: n + (S.silver ? 'A' : '') })) + '">' + n + (S.silver ? 'A' : '') + '</span>' + L.fmt[n] + '</strong><span>' + F.size + ' · ' + F.weight + (S.own ? '' : ' · ' + money(r.price)) + '</span>' +
          '<span class="lnc-compat">' + esc(t('forX', { x: baseNames(compat(n)).join(', ') })) + '</span>' +
          (off ? '<span class="lnc-flag">' + t('soldOut') + '</span>' : '') + '</button>' +
          (q > 0 ? '<div class="lnc-qty"><button type="button" data-k="qm' + n + '" data-a="rqty" data-v="' + r.id + ':-1" aria-label="' + esc(t('less')) + '">−</button><span aria-live="polite">' + tp('pPair', q) + '</span><button type="button" data-k="qp' + n + '" data-a="rqty" data-v="' + r.id + ':1" aria-label="' + esc(t('more')) + '"' + (off || q >= 10 ? ' disabled' : '') + '>+</button></div>' : '') +
          '</div>';
      });
      h += '</div>';
      var A = S.silver ? 'A' : '';
      if (ring && ring.img) h += '<figure class="lnc-ringphoto"><img src="' + esc(ring.img) + '" alt="' + esc(t('photoCap')) + '" loading="lazy" width="350" height="197" style="object-position:center ' + (S.silver ? '36%' : '58%') + '"><figcaption>' + t('photoCap') + '<br><b>1' + A + '</b> ' + L.fmtLc[1] + ' · <b>2' + A + '</b> ' + L.fmtLc[2] + ' · <b>3' + A + '</b> ' + L.fmtLc[3] + ' · <b>4' + A + '</b> ' + L.fmtLc[4] + '</figcaption></figure>';
    } else {
      var r0 = list[0];
      var sumTitle = S.own ? t('ownTitle', { x: L.fmt[S.n] }) : !nbR ? t('noRing') : list.length === 1 ? (nbR > 1 ? nbR + ' × ' : '') + rLong(r0) : tp('pRing', nbR);
      var sumSub = S.own ? (S.fromLink ? FL : t('ownSub')) : !nbR ? t('chooseRingsFirst') : (list.length === 1 ? FORMATS[r0.n].size : list.map(function (r) { return (S.rq[r.id] > 1 ? S.rq[r.id] + ' × ' : '') + lc(rShort(r)); }).join(', ')) + ' · ' + money(ringPrice);
      h += '<div class="lnc-ringsum">' + (r0 ? ringSvg(r0.n, r0.silver, 44) : ringSvg(S.n, S.silver, 44)) + '<div><strong>' + esc(sumTitle) + '</strong><span>' + esc(sumSub) + '</span></div><button type="button" class="lnc-link" data-k="edit" data-a="step" data-v="anneaux">' + t('edit') + '</button></div>';

      var noRing = !S.own && !nbR;
      h += '<p class="lnc-label lnc-label--c">' + esc(noRing ? NR[0] : ns.length === 1 ? t('charmsForOne', { x: L.fmtFor[ns[0]] }) : t('charmsForAll')) + '</p><div class="lnc-models">';
      okList.forEach(function (i) {
        var x = CHARMS[i], cnt = countIn(i);
        h += '<button type="button" class="lnc-model" data-k="m' + i + '" data-a="model" data-v="' + i + '" aria-pressed="' + (S.ci === i) + '"><img src="' + esc(x.thumb) + '" alt="" loading="lazy" width="80" height="80">' +
          (cnt ? '<b class="lnc-count" aria-label="' + esc(t('chosenAria', { n: cnt })) + '">' + cnt + '</b>' : '') +
          '<strong>' + esc(cName(x.name)) + '</strong><span>' + money(x.variants[firstAvail(x)].price) + '</span></button>';
      });
      h += '</div>';
      var offIdx = []; CHARMS.forEach(function (c, i) { if (okList.indexOf(i) === -1) offIdx.push(i); });
      var offNames = baseNames(offIdx);
      if (offNames.length) h += '<p class="lnc-hint" style="margin-top:6px">' + t('notCompat') + esc(offNames.join(', ')) + ' · <button type="button" class="lnc-link" data-k="edit2" data-a="step" data-v="anneaux">' + t('edit') + '</button></p>';

      var c = CHARMS[S.ci];
      var nb = c.variants.filter(function (x) { return x.available; }).length;
      var fits = ns.filter(function (n) { return c.rings.indexOf(n) !== -1; });
      var fitTxt = noRing ? NR[1].replace('{x}', fits.map(function (n) { return (L.fmt || LF.fmt)[n]; }).join(', '))
        : ns.length > 1 && fits.length < ns.length ? t('fits', { x: fits.map(function (n) { return L.fmtFor[n]; }).join(t('and')) }) : '';
      h += '<p class="lnc-label lnc-ctitle"><strong>' + esc(cName(c.name)) + '</strong> · ' + (c.mat === 'acetate' ? t('exclusive', { n: nb }) : t('handmade')) + ' · ' + money(c.variants[firstAvail(c)].price) + '</p>';
      if (fitTxt) h += '<p class="lnc-hint" style="text-align:center">' + esc(fitTxt) + '</p>';
      h += '<div class="lnc-colors">';
      c.variants.forEach(function (x, i) {
        if (c.hasLast && (i === 0 || (x.last && !c.variants[i - 1].last))) h += '<p class="lnc-label lnc-group" style="grid-column:1/-1;flex-basis:100%;width:100%;margin:' + (i ? '16px' : '0') + ' 0 4px;text-align:center"><strong>' + esc(GRP[x.last ? 1 : 0]) + '</strong>' + (x.last ? '<br><small>' + esc(GRP[2]) + '</small>' : '') + '</p>';
        var on = pickIndex(S.ci, i) !== -1;
        h += '<div class="lnc-swc">' + (x.available ? '<button type="button" class="lnc-zoom" data-k="z' + i + '" data-a="zoom" data-v="' + i + '" aria-label="' + esc(t('zoom')) + ' ' + esc(x.label) + '"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5M11 8.5v5M8.5 11h5"/></svg></button>' : '');
        h += '<button type="button" class="lnc-sw" data-k="v' + i + '" data-a="variant" data-v="' + i + '" aria-pressed="' + on + '"' + (x.available ? '' : ' disabled') +
          ' aria-label="' + esc(t(on ? 'remove' : 'add')) + ' ' + esc(x.label) + (x.available ? '' : ', ' + esc(t('soldOutLc'))) + '"><span class="lnc-thumb"><img src="' + esc(x.thumb) + '" alt="" loading="lazy" width="66" height="66"></span><i>' + esc(x.num) + '</i>' +
          (on ? '<b aria-hidden="true">✓</b>' : '') + '<span>' + esc(x.label) + (x.available ? '' : ' · ' + esc(t('soldOutLc'))) + '</span></button></div>';
      });
      h += '</div>';

      h += '<div class="lnc-sel"><p class="lnc-label">' + t('selection') + '</p>';
      list.forEach(function (r) {
        var q = S.rq[r.id];
        h += '<div class="lnc-line">' + ringSvg(r.n, r.silver, 44) + '<div><strong>' + (q > 1 ? q + ' × ' : '') + esc(rLong(r)) + '</strong><span>' + esc(t('ringsLine', { x: FORMATS[r.n].size })) + '</span></div><span class="lnc-price">' + money(r.price * q) + '</span><button type="button" class="lnc-x" data-k="xr' + r.id + '" data-a="step" data-v="anneaux" aria-label="' + esc(t('editRings')) + '">✎</button></div>';
      });
      if (!S.picks.length) h += '<p class="lnc-hint">' + t('noCharm') + '</p>';
      S.picks.forEach(function (p, k) {
        var x = CHARMS[p.ci], v = x.variants[p.vi];
        h += '<div class="lnc-line"><span class="lnc-thumb"><img src="' + esc(v.thumb) + '" alt="" width="44" height="44" loading="lazy"></span><div><strong>' + esc(t('charmsOf', { x: cName(x.name) })) + '</strong><span>' + esc(v.label) + '</span></div><span class="lnc-price">' + money(v.price) + '</span><button type="button" class="lnc-x" data-k="x' + k + '" data-a="remove" data-v="' + k + '" aria-label="' + esc(t('remove') + ' ' + v.label) + '">×</button></div>';
      });
      h += '</div>';
    }

    h += '<label class="lnc-gift' + (S.gift ? ' is-on' : '') + '"><input type="checkbox" data-k="gift" data-a="gift"' + (S.gift ? ' checked' : '') + '><span class="lnc-gift__t"><strong>🎁 ' + t('gift') + '</strong><small>' + t('giftSub') + '</small></span></label>';
    // Jauge : charms surprise + livraison offerte selon le pays
    var spent = S.cart + (S.sheet ? 0 : total);
    var goals = [{ at: SEUIL, icon: ICON.gift, label: 'Charms', msg: t('goalCharms') }];
    if (SHIP > 0) goals.push({ at: SHIP, icon: ICON.truck, label: 'Livraison', msg: t('goalShip') });
    goals.sort(function (x, y) { return x.at - y.at; });
    var top = goals[goals.length - 1].at;
    var nextGoal = goals.filter(function (g) { return spent < g.at; })[0];
    var giftTxt;
    if (nextGoal) giftTxt = esc(t('moreFor', { p: '§', x: nextGoal.msg })).replace('§', '<b>' + money(nextGoal.at - spent) + '</b>') + (SHIP === -1 && nextGoal.label === 'Charms' ? esc(t('plusFree')) : '');
    else giftTxt = SHIP > 0 ? '<b>' + esc(t('allFree')) + '</b>' : '<b>' + esc(t('charmsFree')) + '</b>' + (SHIP === -1 ? esc(t('plusFree')) : '');
    var pct = Math.max(2, Math.min(100, spent / top * 100));
    var marks = '', labels = '';
    goals.forEach(function (g, gi) {
      var at = g.at / top * 100, on = spent >= g.at, last = gi === goals.length - 1;
      marks += '<span class="lnc-mk' + (on ? ' is-on' : '') + '" style="left:' + at + '%">' + g.icon + '</span>';
      labels += '<span class="' + (last ? 'is-last' : '') + (on ? ' is-on' : '') + '" style="left:' + at + '%">' + money(g.at) + '</span>';
    });
    var label, enabled, action;
    if (S.step === 'anneaux') { action = 'next'; enabled = S.own || (nbR > 0 && allAvail); label = S.own || nbR ? (ringOk ? t('chooseCharms') : t('ringsSoldOut')) : t('chooseRings'); }
    else if (!S.own && !nbR && !S.picks.length) { action = 'step'; enabled = true; label = t('chooseRingsFirst'); }
    else if (!S.own && !nbR) { action = 'add'; enabled = true; label = t('addCart', { p: money(total) }); }
    else if (S.picks.length) { action = 'add'; enabled = allAvail; label = t('addCart', { p: money(total) }); }
    else if (S.own || !nbR) { action = 'add'; enabled = false; label = t('chooseOneCharm'); }
    else { action = 'add'; enabled = ringOk; label = t('addRingsOnly', { p: money(ringPrice) }); }
    if (S.busy) { enabled = false; label = t('adding'); }
    var nbItems = S.picks.length + nbR;
    h += '<div class="lnc-bar"><div class="lnc-bar__row"><span aria-live="polite">' + giftTxt + '</span>' + (S.step === 'charms' && S.picks.length ? '<span class="lnc-nb">' + tp('pArticle', nbItems) + '</span>' : '') + '</div>' +
      '<div class="lnc-prog" aria-hidden="true"><div class="lnc-track"><i style="width:' + pct + '%"></i>' + marks + '</div><div class="lnc-marks">' + labels + '</div></div>' +
      '<div class="lnc-ctas">' +
      (S.step === 'anneaux' && !S.own && nbR && ringOk && !S.busy ? '<button type="button" class="lnc-cta2" data-k="cta2" data-a="add">' + esc(t('ringsOnly', { p: money(ringPrice) })) + '</button>' : '') +
      '<button type="button" class="lnc-cta" data-k="cta" data-a="' + action + '"' + (action === 'step' ? ' data-v="anneaux"' : '') + (enabled ? '' : ' disabled') + '>' + esc(label) + '</button></div></div>';
    var shipTxt = SHIP === -1 ? t('shipFree') : SHIP > 0 ? t('shipFrom', { p: money(SHIP) }) : t('shipTracked');
    var trustH = '<ul class="lnc-trust">' +
      '<li>' + ICON.box + '<span>' + t('shipped') + '</span></li>' +
      '<li>' + ICON.van + '<span>' + esc(shipTxt) + (SHIP > 0 && SHIP_MODE ? '<br>' + esc(t(SHIP_MODE)) : '') + '</span></li>' +
      '<li>' + ICON.pouch + '<span>' + t('pouch') + '</span></li></ul>';
    h += trustH;

    if (S.sheet) {
      h += '<div class="lnc-sheet" role="dialog" aria-modal="true" aria-labelledby="' + root.id + '-sh"><div class="lnc-sheet__box">' +
        '<h2 id="' + root.id + '-sh">' + esc(t('inCart')) + '</h2>' +
        '<p>' + esc(S.lastSummary) + '</p>' +
        '<a href="' + ROUTE + 'cart" data-k="cart">' + esc(t('seeCart')) + '</a>' +
        '<button type="button" class="lnc-btn2" data-k="more" data-a="more">' + esc(t('moreCharms')) + '</button>' +
        '<button type="button" class="lnc-btn2" data-k="again" data-a="again">' + esc(t('another')) + '</button></div></div>';
    }

    if (S.zoom !== null && S.step === 'charms') {
      var zc = CHARMS[S.ci], zv = zc.variants[S.zoom];
      if (zv) {
        var zon = pickIndex(S.ci, S.zoom) !== -1;
        h += '<div class="lnc-zwrap" data-a="zclose" role="dialog" aria-modal="true" aria-label="' + esc(t('charmsOf', { x: cName(zc.name) }) + ' ' + zv.label) + '"><div class="lnc-zbox" data-a="noop">' +
          '<button type="button" class="lnc-zx" data-k="zx" data-a="zclose" aria-label="' + esc(t('close')) + '">×</button>' +
          '<div class="lnc-zimg"><img src="' + esc(zv.img) + '" alt="' + esc(t('charmsOf', { x: cName(zc.name) }) + ' ' + zv.label) + '" width="450" height="450">' +
          '<button type="button" class="lnc-znav lnc-znav--p" data-k="zp" data-a="zprev" aria-label="' + esc(t('prev')) + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
          '<button type="button" class="lnc-znav lnc-znav--n" data-k="zn" data-a="znext" aria-label="' + esc(t('next')) + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button></div>' +
          '<p class="lnc-ztitle"><span class="lnc-num">' + esc(zv.num) + '</span>' + esc(zv.label) + '</p>' +
          '<p class="lnc-zsub">' + esc(t('charmsOf', { x: cName(zc.name) })) + ' · ' + esc(t('perPair', { p: money(zv.price) })) + (zv.available ? '' : ' · ' + esc(t('soldOutLc'))) + '</p>' +
          '<button type="button" class="lnc-cta" data-k="zt" data-a="ztoggle"' + (zv.available ? '' : ' disabled') + '>' + esc(t(zon ? 'remSel' : 'addSel')) + '</button>' +
          '</div></div>';
      }
    }

    app.innerHTML = h;
    if (keep) { var el = app.querySelector('[data-k="' + keep + '"]'); if (el) el.focus({ preventScroll: true }); }
    else if (S.sheet) { var b = app.querySelector('[data-k="cart"]'); if (b) b.focus(); }
  }

  function refreshCart() {
    return fetch(ROUTE + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { S.cart = cart.total_price || 0; return cart; })
      .catch(function () {});
  }

  // Case « C'est un cadeau » : on écrit « Cadeau » dans la note du panier (sans doublon)
  function markGift() {
    return fetch(ROUTE + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var note = cart.note || '';
        if (/cadeau/i.test(note)) return;
        return fetch(ROUTE + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note ? note + '\nCadeau' : 'Cadeau' })
        });
      })
      .catch(function () {});
  }

  function add() {
    var list = S.own ? [] : ringList(), nbR = S.own ? 0 : nbRings();
    var items = S.picks.map(function (p) { return { id: CHARMS[p.ci].variants[p.vi].id, quantity: 1 }; });
    list.slice().reverse().forEach(function (r) { items.unshift({ id: r.id, quantity: S.rq[r.id] }); });
    if (!items.length) return;
    var parts = [];
    if (list.length === 1) parts.push((nbR > 1 ? nbR + ' × ' : '') + rLong(list[0]));
    else if (nbR) parts.push(tp('pRing', nbR));
    if (S.picks.length) parts.push(tp('pCharm', S.picks.length));
    var summary = parts.join(' + ') + '.' + (S.picks.length ? ' ' + t('howTo') : '');
    set({ busy: true });
    fetch(ROUTE + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; }); })
      .then(function () { return S.gift ? markGift() : null; })
      .then(function () { return refreshCart(); })
      .then(function () {
        ['cart:refresh', 'cart:change'].forEach(function (name) {
          try { document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true })); } catch (e) {}
          try { document.dispatchEvent(new CustomEvent(name, { bubbles: true })); } catch (e) {}
        });
        if (list.length) S.n = list[0].n;
        // Le panier latéral (appli Opus ou panier du thème) s'ouvre tout seul après l'ajout :
        // dans ce cas, pas de fenêtre par-dessus. Le configurateur passe directement à
        // « ajouter d'autres charms », et c'est ce que la cliente retrouve en fermant le panier.
        var lastSummary = summary + (S.gift ? ' ' + t('giftNoted') : '');
        S.lastRings = list.length > 0;
        var afterDrawer = { busy: false, sheet: false, own: S.lastRings ? true : S.own, step: 'charms', note: S.lastRings ? t('inCartMore') : CIN, picks: [], lastSummary: lastSummary };
        if (cartDrawerOpen()) { set(afterDrawer); return; }
        set({ busy: false, sheet: true, note: '', picks: [], lastSummary: lastSummary });
        var tries = 0;
        (function watchDrawer() {
          if (!S.sheet) return;
          if (cartDrawerOpen()) { set(afterDrawer); return; }
          if (++tries < 40) setTimeout(watchDrawer, 150);
        })();
      })
      .catch(function (err) { set({ busy: false, note: t('oops', { x: err.message }) }); });
  }

  app.addEventListener('change', function (e) {
    if (e.target.matches('[data-a="own"]')) { S.own = e.target.checked; set(prunePicks()); }
    else if (e.target.matches('[data-a="gift"]')) set({ gift: e.target.checked });
  });
  app.addEventListener('click', function (e) {
    var tg = e.target.closest('[data-a]'); if (!tg || !app.contains(tg)) return;
    var a = tg.getAttribute('data-a'), val = tg.getAttribute('data-v');
    if (a === 'own' || a === 'gift' || a === 'noop') return;
    if (a === 'zoom') { set({ zoom: Number(val) }); return; }
    if (a === 'zclose') { set({ zoom: null }); return; }
    if (a === 'zprev' || a === 'znext') { set({ zoom: nextAvail(S.zoom, a === 'znext' ? 1 : -1) }); return; }
    if (a === 'ztoggle') { set({ picks: togglePick(S.ci, S.zoom) }); return; }
    if (a === 'finish') set({ silver: val === '1' });
    else if (a === 'note') set({ note: '' });
    else if (a === 'step') { set({ step: val }); toTop(); }
    else if (a === 'next') { set({ step: 'charms', note: '' }); toTop(); }
    else if (a === 'ring') {
      var n = Number(val);
      S.n = n;
      if (!S.own) {
        var r = ringOf(n, S.silver); if (!r) return;
        var rq = {}; for (var id in S.rq) rq[id] = S.rq[id];
        if (rq[r.id]) delete rq[r.id];
        else if (r.available) rq[r.id] = 1;
        else { set({ note: t('ringSoldOutNote') }); return; }
        S.rq = rq;
      }
      set(prunePicks());
    }
    else if (a === 'rqty') {
      var parts2 = val.split(':'), rid = parts2[0], d = Number(parts2[1]);
      var rq2 = {}; for (var id2 in S.rq) rq2[id2] = S.rq[id2];
      var nq = Math.max(0, Math.min(10, (rq2[rid] || 0) + d));
      if (nq) rq2[rid] = nq; else delete rq2[rid];
      S.rq = rq2;
      set(prunePicks());
    }
    else if (a === 'model') set({ ci: Number(val), zoom: null });
    else if (a === 'variant') {
      var vi = Number(val), k = pickIndex(S.ci, vi);
      var picks = S.picks.slice();
      if (k === -1) picks.push({ ci: S.ci, vi: vi }); else picks.splice(k, 1);
      set({ picks: picks });
    }
    else if (a === 'remove') { var p2 = S.picks.slice(); p2.splice(Number(val), 1); set({ picks: p2 }); }
    else if (a === 'add') add();
    else if (a === 'more') { set({ sheet: false, own: S.lastRings ? true : S.own, step: 'charms', note: S.lastRings ? t('inCartMore') : CIN }); toTop(); }
    else if (a === 'again') { set({ sheet: false, own: false, step: 'anneaux', note: '', rq: defaultRings() }); toTop(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && S.zoom !== null) set({ zoom: null });
    else if (e.key === 'Escape' && S.sheet) set({ sheet: false });
    else if (S.zoom !== null && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) set({ zoom: nextAvail(S.zoom, e.key === 'ArrowRight' ? 1 : -1) });
  });

  render();
  refreshCart().then(render);
  }
})();